export default "__VITE_ASSET__BqXX6__k__"